import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Name the Alert",
    opening: localizedGenderNode(
      [
      "Today I do not force calm.",
      "I only notice: there is alertness in me."
    ],
      [
      "Today I do not force calm.",
      "I only notice: there is alertness in me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How does the alertness feel in my body?",
      "When is it strongest?",
      "What is the first thought that rises?"
    ],
      [
      "How does the alertness feel in my body?",
      "When is it strongest?",
      "What is the first thought that rises?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Alertness is an experience, not a prophecy."
    ],
      [
      "Alertness is an experience, not a prophecy."
    ]
    ),
    action: localizedGenderNode(
      "one breath + \"There is alertness in me, and I am with myself\".",
      "one breath + \"There is alertness in me, and I am with myself\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "The First Moment",
    opening: localizedGenderNode(
      [
      "Today I notice the first moment the alertness rises.",
      "I only notice."
    ],
      [
      "Today I notice the first moment the alertness rises.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When in the day does it start?",
      "What does my body do first?",
      "What am I trying to prevent?"
    ],
      [
      "When in the day does it start?",
      "What does my body do first?",
      "What am I trying to prevent?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "In the first moment I have a little space."
    ],
      [
      "In the first moment I have a little space."
    ]
    ),
    action: localizedGenderNode(
      "one breath when the alertness rises.",
      "one breath when the alertness rises."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Body Before Thought",
    opening: localizedGenderNode(
      [
      "Today I give my body space before the story.",
      "I stay with myself."
    ],
      [
      "Today I give my body space before the story.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my breath.",
      "One breath."
    ],
      [
      "I notice my breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where does the alertness sit in my body?",
      "What is my body trying to protect?",
      "What could soften a little?"
    ],
      [
      "Where does the alertness sit in my body?",
      "What is my body trying to protect?",
      "What could soften a little?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "My body is trying to protect me."
    ],
      [
      "My body is trying to protect me."
    ]
    ),
    action: localizedGenderNode(
      "a hand on my chest and one breath.",
      "a hand on my chest and one breath."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "The Disaster Story",
    opening: localizedGenderNode(
      [
      "Today I notice the story that tells of disaster.",
      "I do not fight it."
    ],
      [
      "Today I notice the story that tells of disaster.",
      "I do not fight it."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe in and out.",
      "One breath."
    ],
      [
      "I breathe in and out.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What scenario jumps in first?",
      "What feels most frightening in it?",
      "What softer possibility could also be true?"
    ],
      [
      "What scenario jumps in first?",
      "What feels most frightening in it?",
      "What softer possibility could also be true?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A story is not a fact."
    ],
      [
      "A story is not a fact."
    ]
    ),
    action: localizedGenderNode(
      "an inner sentence - \"This is a story rising\".",
      "an inner sentence - \"This is a story rising\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Daily Triggers",
    opening: localizedGenderNode(
      [
      "Today I notice what ignites the alertness.",
      "This is knowledge, not blame."
    ],
      [
      "Today I notice what ignites the alertness.",
      "This is knowledge, not blame."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I sit with myself for a moment.",
      "One breath."
    ],
      [
      "I sit with myself for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the trigger that sets me off?",
      "When does it return?",
      "What do I need there?"
    ],
      [
      "What is the trigger that sets me off?",
      "When does it return?",
      "What do I need there?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Naming it is already a small calm."
    ],
      [
      "Naming it is already a small calm."
    ]
    ),
    action: localizedGenderNode(
      "write one trigger word.",
      "write one trigger word."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Scanning for Danger",
    opening: localizedGenderNode(
      [
      "Today I notice the habit of scanning for danger.",
      "I only notice."
    ],
      [
      "Today I notice the habit of scanning for danger.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my feet.",
      "One breath."
    ],
      [
      "I feel my feet.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where do I look for signs?",
      "What do I believe will protect me if I catch it in time?",
      "What happens to me after I scan?"
    ],
      [
      "Where do I look for signs?",
      "What do I believe will protect me if I catch it in time?",
      "What happens to me after I scan?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I do not have to scan every moment."
    ],
      [
      "I do not have to scan every moment."
    ]
    ),
    action: localizedGenderNode(
      "one moment without checking.",
      "one moment without checking."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "The Need for Safety",
    opening: localizedGenderNode(
      [
      "Today I touch the need for safety beneath the alertness.",
      "I stay with myself."
    ],
      [
      "Today I touch the need for safety beneath the alertness.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "One breath."
    ],
      [
      "I breathe slowly.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I trying to get through alertness?",
      "What sense of safety is missing?",
      "How does it feel when there is a little safety?"
    ],
      [
      "What am I trying to get through alertness?",
      "What sense of safety is missing?",
      "How does it feel when there is a little safety?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Behind alertness there is a request."
    ],
      [
      "Behind alertness there is a request."
    ]
    ),
    action: localizedGenderNode(
      "write one request to myself.",
      "write one request to myself."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "An Inner Boundary",
    opening: localizedGenderNode(
      [
      "Today I set an inner boundary for the alertness.",
      "Without a fight."
    ],
      [
      "Today I set an inner boundary for the alertness.",
      "Without a fight."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel my shoulders soften a little.",
      "One breath."
    ],
      [
      "I feel my shoulders soften a little.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does not fit me in this load?",
      "How does my body signal that it is too much?",
      "What inner sentence can slow it down?"
    ],
      [
      "What does not fit me in this load?",
      "How does my body signal that it is too much?",
      "What inner sentence can slow it down?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "An inner boundary lowers intensity."
    ],
      [
      "An inner boundary lowers intensity."
    ]
    ),
    action: localizedGenderNode(
      "a quiet sentence - \"This is enough for now\".",
      "a quiet sentence - \"This is enough for now\"."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Fear Beneath",
    opening: localizedGenderNode(
      [
      "Today I meet the fear beneath the alertness.",
      "I stay with it for a moment."
    ],
      [
      "Today I meet the fear beneath the alertness.",
      "I stay with it for a moment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe into the tender place.",
      "One breath."
    ],
      [
      "I breathe into the tender place.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I afraid will happen?",
      "What hurts most in that thought?",
      "What do I need to hear now?"
    ],
      [
      "What am I afraid will happen?",
      "What hurts most in that thought?",
      "What do I need to hear now?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Fear wants protection, not a fight."
    ],
      [
      "Fear wants protection, not a fight."
    ]
    ),
    action: localizedGenderNode(
      "name the fear quietly.",
      "name the fear quietly."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "A Small Trust",
    opening: localizedGenderNode(
      [
      "Today I look for a small point of trust.",
      "Not a big one."
    ],
      [
      "Today I look for a small point of trust.",
      "Not a big one."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel the air come in and out.",
      "One breath."
    ],
      [
      "I feel the air come in and out.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When in the past did the alertness calm?",
      "What helped even a little?",
      "What small thing can I trust today?"
    ],
      [
      "When in the past did the alertness calm?",
      "What helped even a little?",
      "What small thing can I trust today?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small trust is enough to begin."
    ],
      [
      "A small trust is enough to begin."
    ]
    ),
    action: localizedGenderNode(
      "remember one thing that helps.",
      "remember one thing that helps."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Back to the Body",
    opening: localizedGenderNode(
      [
      "Today I return to my body when I drift.",
      "I am with myself."
    ],
      [
      "Today I return to my body when I drift.",
      "I am with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel the weight of my body.",
      "One breath."
    ],
      [
      "I feel the weight of my body.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What brings me back to presence?",
      "What kind of breath feels good to me?",
      "What do I feel right now?"
    ],
      [
      "What brings me back to presence?",
      "What kind of breath feels good to me?",
      "What do I feel right now?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Presence lowers the noise."
    ],
      [
      "Presence lowers the noise."
    ]
    ),
    action: localizedGenderNode(
      "one slow breath with a hand on my belly.",
      "one slow breath with a hand on my belly."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "A Moment Before the Urge",
    opening: localizedGenderNode(
      [
      "Today I give a quiet moment before the urge to check.",
      "I can wait a moment."
    ],
      [
      "Today I give a quiet moment before the urge to check.",
      "I can wait a moment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice this moment.",
      "One breath."
    ],
      [
      "I notice this moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is my first urge when I am on alert?",
      "What happens if I wait a moment?",
      "What do I discover after waiting?"
    ],
      [
      "What is my first urge when I am on alert?",
      "What happens if I wait a moment?",
      "What do I discover after waiting?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A quiet moment is a choice."
    ],
      [
      "A quiet moment is a choice."
    ]
    ),
    action: localizedGenderNode(
      "pause before checking.",
      "pause before checking."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A Small Step",
    opening: localizedGenderNode(
      [
      "Today I choose a small step inside the alertness.",
      "Not a revolution."
    ],
      [
      "Today I choose a small step inside the alertness.",
      "Not a revolution."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly and look around.",
      "One breath."
    ],
      [
      "I breathe slowly and look around.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step calms me?",
      "When can I do it?",
      "What will help me remember?"
    ],
      [
      "What small step calms me?",
      "When can I do it?",
      "What will help me remember?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Small enough is enough."
    ],
      [
      "Small enough is enough."
    ]
    ),
    action: localizedGenderNode(
      "choose one small step.",
      "choose one small step."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return Sentence",
    opening: localizedGenderNode(
      [
      "Today I finish with a sentence that returns me to myself.",
      "I choose presence."
    ],
      [
      "Today I finish with a sentence that returns me to myself.",
      "I choose presence."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause a moment before response.",
      "One breath."
    ],
      [
      "I pause a moment before response.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this alertness?",
      "What is the first sign it rises?",
      "What is my short sentence?"
    ],
      [
      "What did I learn about this alertness?",
      "What is the first sign it rises?",
      "What is my short sentence?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I choose a moment before response."
    ],
      [
      "I choose a moment before response."
    ]
    ),
    action: localizedGenderNode(
      "one breath + my sentence.",
      "one breath + my sentence."
    ),
  },
].map(buildNormalizedDay);

export const anxietyVigilanceBlueprintEn = buildNormalizedPilotBlueprint({
  id: "anxiety_vigilance_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "anxiety_vigilance",
  category: "anxiety",
  journeyName: {
    he: "תחושת דריכות תמידית / אסון עוד רגע מגיע",
    en: "Constant vigilance / a disaster is about to happen",
    es: "Sensación de alerta constante / algo malo por pasar",
  },
  days,
});

export default anxietyVigilanceBlueprintEn;
